import { motion } from "framer-motion";
import { CheckCircle2, BadgePercent } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { IMAGES } from "@/lib/constants";
import { QuoteForm } from "@/components/QuoteForm";

export const QuoteSection = () => {
    const { t } = useLang();

    return (
        <section id="get-offer" data-testid="quote-section" className="relative py-20 lg:py-28">
            <div className="pointer-events-none absolute inset-0" aria-hidden="true">
                <div className="absolute top-1/3 -left-32 h-[420px] w-[420px] rounded-full bg-volt/[0.07] blur-[120px]" />
            </div>

            <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="grid items-center gap-12 lg:grid-cols-12">
                    <motion.div
                        initial={{ opacity: 0, y: 32 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.15 }}
                        transition={{ duration: 0.7 }}
                        className="lg:col-span-5 text-center lg:text-left"
                    >
                        <span className="inline-flex items-center gap-2 rounded-full border border-volt/30 bg-volt/10 px-4 py-1.5 text-xs font-extrabold uppercase tracking-[0.15em] text-volt">
                            <BadgePercent className="h-3.5 w-3.5" />
                            {t("quote.eyebrow")}
                        </span>
                        <h2 className="mt-5 font-display text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-white">
                            {t("quote.h")}
                        </h2>
                        <p className="mt-4 text-base leading-relaxed text-slate-400">{t("quote.sub")}</p>

                        <ul className="mt-7 space-y-3 text-left inline-block">
                            {t("quote.bullets").map((b, i) => (
                                <li key={i} className="flex items-center gap-3 text-sm font-bold text-slate-200">
                                    <CheckCircle2 className="h-5 w-5 shrink-0 text-volt" />
                                    {b}
                                </li>
                            ))}
                        </ul>

                        <div className="relative mt-9 hidden lg:block overflow-hidden rounded-3xl border border-white/10">
                            <img
                                src={IMAGES.garage}
                                alt=""
                                loading="lazy"
                                className="h-56 w-full object-cover opacity-80"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-transparent to-transparent" />
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 32 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.1 }}
                        transition={{ duration: 0.7, delay: 0.15 }}
                        className="lg:col-span-7"
                    >
                        <div className="rounded-3xl border border-white/10 bg-surface/90 p-6 sm:p-8 lg:p-10 shadow-[0_30px_80px_rgba(0,0,0,0.45)] backdrop-blur">
                            <QuoteForm />
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default QuoteSection;
